import { ObjectDirective } from 'vue';

import { analytics, BTN_EVTS, LogEvent } from '@/common/logs';
import { logger } from '@/common/api/logger';

interface HTMLElementWithClickHandler extends HTMLElement {
  __vueClickHandler__?: (e: Event) => void;
}

const TrackClickDirective: ObjectDirective<HTMLElementWithClickHandler> = {
  bind(el: HTMLElementWithClickHandler, binding) {
    const handleButtonClick = (e: Event) => {
      const eventData = binding.value as unknown as keyof typeof BTN_EVTS | LogEvent;

      if (!eventData) {
        logger.error('[TRACK_CLICK] Invalid event for ButtonClickDirective', { eventData });
        return;
      }

      if (typeof eventData === 'string') {
        analytics.trackClick({ name: eventData });
      } else if (typeof eventData === 'object') {
        const { name, selection, metadata } = eventData;
        analytics.trackClick({ name, selection, metadata });
      }
    };

    el.__vueClickHandler__ = handleButtonClick;

    // We need to use { capture: true } because if there are other click event handlers
    // (e.g., in the parent component or other directives) that call e.stopPropagation(),
    // bubbling-phase event listener won't trigger because the event is stopped before
    // it reaches this directive.
    el.addEventListener('click', handleButtonClick, { capture: true });
  },

  unbind(el: HTMLElementWithClickHandler) {
    // Remove the event listener when the directive is unbound
    const handler = el.__vueClickHandler__;
    if (handler) {
      el.removeEventListener('click', handler, { capture: true });
      delete el.__vueClickHandler__;
    }
  },
};

// Keep here so events can be imported from this file with directive
export { BTN_EVTS };
export default TrackClickDirective;
